import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import './FeedFilterBar.scss';
import RankingButton from '../../Content/Feed/RankingComponent/RankingButton/RankingButton';
import AllPostsIcon from '../../Icons/AllPosts/AllPostsIcon';
import TrendingIcon from '../../Icons/Trending/TrendingIcon';
import AlarmClockIcon from '../../Icons/AlarmClock/AlarmClockIcon';
import LikesIcon from '../../Icons/Likes/LikesIcon';
import { CommunityContext } from '../../../contexts/ContextCreator';

const FeedFilterBar = ({ setIsLoading }) => {
    const { sort, setSort } = useContext(CommunityContext);

    const setNewSort = (type) => {
        if (type !== sort) {
            setIsLoading(false, true);
            setSort(type, setIsLoading);
        }
    };

    const isActive = (type) => sort === type;

    return (
        <div className="component-Community-FeedFilterBar">
            <p className="filter-title-label">Sort posts by</p>
            <div className="menu-display">
                <div
                    className={`feedFilter-item ${
                        isActive('DEFAULT') ? 'active-item' : ''
                    }`}
                >
                    <RankingButton
                        className="all-posts"
                        isActive={isActive('DEFAULT')}
                        setSort={setNewSort}
                        buttonLabel="All"
                        icon={AllPostsIcon}
                        closeDropdown={() => {}}
                        type="DEFAULT"
                    />
                </div>
                <div
                    className={`feedFilter-item ${
                        isActive('TRENDING') ? 'active-item' : ''
                    }`}
                >
                    <RankingButton
                        className="top-posts"
                        setSort={setNewSort}
                        buttonLabel="Top"
                        isActive={sort === 'TRENDING'}
                        icon={TrendingIcon}
                        closeDropdown={() => {}}
                        type="TRENDING"
                    />
                </div>
                <div
                    className={`feedFilter-item ${
                        isActive('RECENT') ? 'active-item' : ''
                    }`}
                >
                    <RankingButton
                        className="new-posts"
                        setSort={setNewSort}
                        buttonLabel="New"
                        isActive={sort === 'RECENT'}
                        icon={AlarmClockIcon}
                        closeDropdown={() => {}}
                        type="RECENT"
                    />
                </div>
                <div
                    className={`feedFilter-item ${
                        isActive('NEED_LOVE') ? 'active-item' : ''
                    }`}
                >
                    <RankingButton
                        className="needs-love"
                        setSort={setNewSort}
                        buttonLabel="Need love"
                        icon={LikesIcon}
                        isActive={sort === 'NEED_LOVE'}
                        closeDropdown={() => {}}
                        type="NEED_LOVE"
                    />
                </div>
            </div>
        </div>
    );
};

FeedFilterBar.propTypes = {
    setIsLoading: PropTypes.func.isRequired,
};

FeedFilterBar.displayName = 'FeedFilterBar';

export default React.memo(FeedFilterBar);
